export default {
  setCompaniesData(state, companies) {
    state.companies = companies;
  }
}
